import React from 'react';
import Axios from 'axios';
import { Tooltip } from 'reactstrap';
import { ConnectedUserContext } from '../../connectedUser-context';

// TEAMS: Standard 8-ball standings - Single only, with round points
// ConfigIdx 0: Standard
// ConfigIdx 1: QVNEA-League (not finals) QVNEA-IPS
// ConfigIdx 2: QVNEA-League (finals) QVNEA-IPS / QVNEA-IPS-MATCHS
// ConfigIdx 3: QVNEA-Tournament
// ConfigIdx 4: BARAQUE-500

import * as myConstClass from '../../shared/constants/constants';

const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_NOACCESS = 99;

// Constants for this standings
const cstTableHeaders = [
[
	'Rang',	'Équipe',	'RG', 'PJ', 'VIC', 'DEF', '% VIC', 
	'PP',	'PC', 'DIFF',	'ERO', 'EC', '10-0', 'MOY', 'Domicile', '#players'
],[
	'Rang',	'Équipe', 'RG', 'RT', '% RG', 'PJ', 'VIC', 'DEF', '% VIC', 
	'PP',	'PC', 'DIFF',	'ERO',	'EC', 'TVP', 'TVC', '10-0', 'MOY', 'Domicile', '#players'
],[
	'Rang',	'Équipe',	'MG', '% MG',	'PJ', 'VIC', 'DEF', '% VIC', 
	'PP',	'PC', 'DIFF',	'ERO', 'EC', 'TVP', 'TVC', '10-0', 'MOY', 'Domicile', '#players'
],[
	'Rang',	'Équipe',	'MG',	'% MG', 'PJ', 'VIC', 'DEF', '% VIC', 
	'PP',	'PC', 'DIFF',	'ERO', 'EC', 'TVP', 'TVC', '10-0', 'MOY', 'Domicile', '#players'
],[
	'Rang',	'Équipe',	'MJ', 'PJ', 'PP', 'PC', 'DIFF',	'HDCP', 'PTS TOT', 'MOY-500', 'Domicile', '#players'
],
];

const cstDefaultSortOrder = [
[
	'','asc','desc', 'desc','desc', 'desc','desc',
	'desc','desc', 'desc','desc', 'desc','desc', 'desc', 'asc'
],[
	'','asc','desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc',
	'desc','desc', 'desc','desc', 'desc','desc','desc','desc', 'desc', 'asc'
],[
	'','asc','desc', 'desc','desc','desc', 'desc','desc',
	'desc','desc', 'desc','desc', 'desc','desc','desc','desc', 'desc', 'asc'
],[
	'','asc','desc', 'desc','desc','desc', 'desc','desc',
	'desc','desc', 'desc','desc', 'desc','desc','desc','desc', 'desc', 'asc'
],[
	'', 'asc', 'desc', 'desc','desc','desc', 'desc','desc', 'desc', 'desc', 'desc','asc'
],
];

const cstFixedDecimalsStats = [
[
	{fieldIdx: 2, decimals: 1},
	{fieldIdx: 6, decimals: 2},
	{fieldIdx: 13, decimals: 2}
],[
	{fieldIdx: 2, decimals: 1},
	{fieldIdx: 4, decimals: 1},
	{fieldIdx: 8, decimals: 1},
	{fieldIdx: 17, decimals: 2}
],[
	{fieldIdx: 2, decimals: 1},
	{fieldIdx: 3, decimals: 1},
	{fieldIdx: 7, decimals: 1},
	{fieldIdx: 16, decimals: 2}
],[
	{fieldIdx: 2, decimals: 1},
	{fieldIdx: 3, decimals: 1},
	{fieldIdx: 7, decimals: 1},
	{fieldIdx: 16, decimals: 2}
],[
	{fieldIdx: 7, decimals: 2},
	{fieldIdx: 8, decimals: 2},
	{fieldIdx: 9, decimals: 2},
],
];

const cstDefaultSortFieldIdx = [2, 4, 3, 3, 8];
const cstDefaultSortFieldIdx2 = [6, 8, 7, 7, 4];
const cstDefaultSortFieldIdx3 = [7, 9, 8, 8, 1];


class TeamStandings_8B extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);

		this.state = {
			configIdx: 0,
			tableHeaders: cstTableHeaders[0],
			fixedDecimalsStats: cstFixedDecimalsStats[0],
			sortOrder: cstDefaultSortOrder[0][cstDefaultSortFieldIdx[0]],
			sortFieldIdx: cstDefaultSortFieldIdx[0],

			sortStandingIdx: 0,
			standings: [],
			standingsData: [],
			standingIdx: 0,

			summaryStats: {
				totalPJ: 0,
				totalTV: 0,
				totalERO: 0
			},

			tooltipOpen: [false],
		};
	
		this.createSelectItem = this.createSelectItem.bind(this);
		this.standTypeChange = this.standTypeChange.bind(this);
		this.createStandingHdrRow = this.createStandingHdrRow.bind(this);
		this.createStandingRow = this.createStandingRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
		this.toggleTooltip = this.toggleTooltip.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
		this.printTable = this.printTable.bind(this);
	}

	componentDidMount() {
		this.initStandings(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.initStandings(nextProps);
	}

	initStandings(props) {
		var standings = props.standings;
		//console.log('initStandings');
		//console.log(standings);

		var tooltipOpen = new Array(standings[0].results.length).fill(false);

		// Set Config Index according to stateloLeagueParam
		var configIdx = 0;
		if (props.season.stateloLeagueParam.includes('QVNEA')) {
			// tournament type
			if (props.bTournamentType) {
				configIdx = 3;
			} 
			// league type
			else {
				if ((props.season.stateloLeagueParam.includes('MATCHS')) || props.bDispFinalsStatsType) {
					configIdx = 2;
				} else {
					configIdx = 1;
				}
			}
		}
		if (props.season.stateloLeagueParam.includes('BARAQUE-500')) {
			configIdx = 4;
		}

		// ----------------------------------------------------------
		// SPECIAL CASES

		// Double and Individual Leagues of summer 2022
		// Sort by MG first (good for RG in config 1 too)
		if (props.season.stateloLeagueParam.includes('SORTMG')) {
			cstDefaultSortFieldIdx[configIdx] = 2;	// (MG in config 2 and 3, RG in config 0 and 1)
		}

		//console.log('initStandings');
		//console.log("configIdx: " + configIdx);

		// --------------------------------------------------------
		// SUMMARY STATS
		var summaryStats = {
			totalPJ: 0,
			totalTV: 0,
			totalERO: 0
		};

		standings[props.standingIdx].results.forEach(sdr => {
			summaryStats.totalPJ += sdr.gamesPlayedAll;
			summaryStats.totalTV += sdr.tvAll;
			summaryStats.totalERO += sdr.eroAll;
		});
		summaryStats.totalPJ /= 2;
		// console.log('summaryStats: ', summaryStats);

		this.createStandingsData(standings, configIdx);

		this.setState({
			configIdx: configIdx,
			tableHeaders: cstTableHeaders[configIdx],
			fixedDecimalsStats: cstFixedDecimalsStats[configIdx],

			sortOrder: cstDefaultSortOrder[configIdx][cstDefaultSortFieldIdx[configIdx]],
			sortFieldIdx: cstDefaultSortFieldIdx[configIdx],

			standings: standings,
			standingIdx: props.standingIdx,

			summaryStats: summaryStats,

			tooltipOpen: tooltipOpen,
			bDispFinalsStatsType:  props.bDispFinalsStatsType,
		});
	}

	createStandingsData(standings, configIdx) {

		var _this = this;
		var standingsData = [];

		//console.log('STANDINGS!   ConfigIdx:', configIdx);
		//console.log(standings);

		// Parse standings
		standings.forEach(function(standItem, standIdx) {

			var tableData = [];

			// Parse results
			standItem.results.forEach(function(result, resultIdx) {

				var standingRow = [];

				switch(configIdx) {
					// STANDARD
					case 0:
						standingRow.push(0);
						standingRow.push(result.teamName);
						standingRow.push(result.roundsWin);

						// added on 2022-06-25
						standingRow.push(result.gamesPlayedAll);
						standingRow.push(result.gamesWonAll);
						standingRow.push(result.gamesLostAll);
						standingRow.push(result.pctWinAll);
						standingRow.push(result.pointsForAll);
						standingRow.push(result.pointsAgainstAll);
						standingRow.push(result.diffAll);
						standingRow.push(result.eroAll);
						standingRow.push(result.eroContreAll);
						standingRow.push(result.dixzeroAll);
						standingRow.push(result.avgAll);
/*												
						standingRow.push(result.gamesPlayed[0]);
						standingRow.push(result.gamesWon[0]);
						standingRow.push(result.gamesLost[0]);
						standingRow.push(result.pctWin[0]);
						standingRow.push(result.pointsFor[0]);
						standingRow.push(result.pointsAgainst[0]);
						standingRow.push(result.diff[0]);
						standingRow.push(result.ero[0]);
						standingRow.push(result.eroContre[0]);
						standingRow.push(result.dixzero[0]);
						standingRow.push(result.avg[0]);
*/
						standingRow.push(result.homeSite);
						standingRow.push(result.players);
						break;
						
					case 1:
						standingRow.push(0);
						standingRow.push(result.teamName);
						standingRow.push(result.roundsWin);
						standingRow.push(result.roundsTotal);
						standingRow.push(result.roundsWinPct);

						// added on 2022-06-25
						standingRow.push(result.gamesPlayedAll);
						standingRow.push(result.gamesWonAll);
						standingRow.push(result.gamesLostAll);
						standingRow.push(result.pctWinAll);
						standingRow.push(result.pointsForAll);
						standingRow.push(result.pointsAgainstAll);
						standingRow.push(result.diffAll);
						standingRow.push(result.eroAll);
						standingRow.push(result.eroContreAll);
						standingRow.push(result.tvAll);
						standingRow.push(result.tvContreAll);
						standingRow.push(result.dixzeroAll);
						standingRow.push(result.avgAll);
/*
						standingRow.push(result.gamesPlayed[0]);
						standingRow.push(result.gamesWon[0]);
						standingRow.push(result.gamesLost[0]);
						standingRow.push(result.pctWin[0]);
						standingRow.push(result.pointsFor[0] + result.pointsHandicapFor);						// 2020-09-22
						standingRow.push(result.pointsAgainst[0] + result.pointsHandicapAgainst);		// 2020-09-22
						standingRow.push(result.diff[0]);
						standingRow.push(result.ero[0]);
						standingRow.push(result.eroContre[0]);
						standingRow.push(result.tv[0]);
						standingRow.push(result.tvContre[0]);
						standingRow.push(result.dixzero[0]);
						standingRow.push(result.avg[0]);
*/
						standingRow.push(result.homeSite);
						standingRow.push(result.players);
						break;

					case 2:
						standingRow.push(0);
						standingRow.push(result.teamName);
						standingRow.push(result.matchsWin);
						standingRow.push(result.matchsWinPct);

						// added on 2022-06-25
						standingRow.push(result.gamesPlayedAll);
						standingRow.push(result.gamesWonAll);
						standingRow.push(result.gamesLostAll);
						standingRow.push(result.pctWinAll);
						standingRow.push(result.pointsForAll);
						standingRow.push(result.pointsAgainstAll);
						standingRow.push(result.diffAll);
						standingRow.push(result.eroAll);
						standingRow.push(result.eroContreAll);
						standingRow.push(result.tvAll);
						standingRow.push(result.tvContreAll);
						standingRow.push(result.dixzeroAll);
						standingRow.push(result.avgAll);
/*
						standingRow.push(result.gamesPlayed[0]);
						standingRow.push(result.gamesWon[0]);
						standingRow.push(result.gamesLost[0]);
						standingRow.push(result.pctWin[0]);
						standingRow.push(result.pointsFor[0]);
						standingRow.push(result.pointsAgainst[0]);
						standingRow.push(result.diff[0]);
						standingRow.push(result.ero[0]);
						standingRow.push(result.eroContre[0]);
						standingRow.push(result.tv[0]);
						standingRow.push(result.tvContre[0]);
						standingRow.push(result.dixzero[0]);
						standingRow.push(result.avg[0]);
*/
						standingRow.push(result.homeSite);
						standingRow.push(result.players);
						break;

					case 3:
						standingRow.push(0);
						standingRow.push(result.teamName);
						standingRow.push(result.roundsWin);
						standingRow.push(result.roundsWinPct);

						// added on 2022-06-25
						standingRow.push(result.gamesPlayedAll);
						standingRow.push(result.gamesWonAll);
						standingRow.push(result.gamesLostAll);
						standingRow.push(result.pctWinAll);
						standingRow.push(result.pointsForAll);
						standingRow.push(result.pointsAgainstAll);
						standingRow.push(result.diffAll);
						standingRow.push(result.eroAll);
						standingRow.push(result.eroContreAll);
						standingRow.push(result.tvAll);
						standingRow.push(result.tvContreAll);
						standingRow.push(result.dixzeroAll);
						standingRow.push(result.avgAll);
/*						
						standingRow.push(result.gamesPlayed[0]);
						standingRow.push(result.gamesWon[0]);
						standingRow.push(result.gamesLost[0]);
						standingRow.push(result.pctWin[0]);
						standingRow.push(result.pointsFor[0]);
						standingRow.push(result.pointsAgainst[0]);
						standingRow.push(result.diff[0]);
						standingRow.push(result.ero[0]);
						standingRow.push(result.eroContre[0]);
						standingRow.push(result.tv[0]);
						standingRow.push(result.tvContre[0]);
						standingRow.push(result.dixzero[0]);
						standingRow.push(result.avg[0]);
*/
						standingRow.push(result.homeSite);
						standingRow.push(result.players);
						break;

					// 'Rang', 'Équipe', 'MJ', 'PJ', 'PP', 'PC', 'DIFF', 'HDCP', 'PTS TOT', 'Domicile'
					case 4:
						var moy500 = 0;
						if (result.matchsPlayed !== 0) {
							moy500 = Math.round((result.pointsFor[0] + result.pointsHandicapFor) / result.matchsPlayed * 100) / 100;
						}

						standingRow.push(0);
						standingRow.push(result.teamName);
						standingRow.push(result.matchsPlayed);
						standingRow.push(result.gamesPlayed[0]);
						standingRow.push(result.pointsFor[0]);
						standingRow.push(result.pointsAgainst[0]);
						standingRow.push(result.diff[0]);
						standingRow.push(result.pointsHandicapFor);
						standingRow.push(Math.round((result.pointsFor[0] + result.pointsHandicapFor) * 100) / 100);
						standingRow.push(moy500);
						standingRow.push(result.homeSite);
						standingRow.push(result.players);
						break;
				}

				tableData.push(standingRow);
			});

			standingsData.push(tableData);
		});

		var sortFieldIdx = cstDefaultSortFieldIdx[configIdx];
		var sortOrder = cstDefaultSortOrder[configIdx][sortFieldIdx];

		// First data sort
		standingsData.forEach(function (standingsItemData, standingsIdx) {
			_this.sortOneStandingsData(configIdx, standingsData, standingsIdx, sortFieldIdx, sortOrder);
		});
	}

	resetAllSorting() {
		var _this = this;
		var configIdx = this.state.configIdx;
		var standingsData = this.state.standingsData;

		var sortFieldIdx = cstDefaultSortFieldIdx[configIdx];
		var sortOrder = cstDefaultSortOrder[configIdx][sortFieldIdx];

		standingsData.forEach(function (standingsItemData, standingsIdx) {
			_this.sortOneStandingsData(configIdx, standingsData, standingsIdx, sortFieldIdx, sortOrder);
		});
	}

	sortOneStandingsData(configIdx, standingsData, standingsIdx, sortFieldIdx, sortOrder) {

		var standingsItemData = standingsData[standingsIdx];

		// Manage empty data
		if (standingsItemData.length !== 0) {

			var sortSign = 1;
			if (sortOrder === 'desc') { 
				sortSign = -1; 
			}

			standingsItemData.sort(function(a, b) {

				var valueA = 0;
				var valueB = 0;
				var compVal = 0;

				var fact1 = 0;
				var fact2 = 0;
				var fact3 = 0;
				var fact4 = 0;

				// Criteria #1
				valueA = a[sortFieldIdx];
				valueB = b[sortFieldIdx];

				switch(typeof a[sortFieldIdx]) {
				    case "date":
						compVal = new Date(valueA) - new Date(valueB);
				        break;
				    case "string":
						compVal = valueA.localeCompare(valueB);
				        break;
				    case "number":
						compVal = valueA - valueB;
				        break;
				    default:
						compVal = 0;
				        break;
				}

				fact1 = (sortSign * compVal);

				// Criteria #2
				valueA = a[cstDefaultSortFieldIdx2[configIdx]];
				valueB = b[cstDefaultSortFieldIdx2[configIdx]];

				switch(typeof a[cstDefaultSortFieldIdx2[configIdx]]) {
			    case "date":
						compVal = new Date(valueA) - new Date(valueB);
		        break;
			    case "string":
						compVal = valueA.localeCompare(valueB);
		        break;
			    case "number":
						compVal = valueA - valueB;
		        break;
			    default:
						compVal = 0;
		        break;
				}

				fact2 = (sortSign * compVal);

				// Criteria #3
				valueA = a[cstDefaultSortFieldIdx3[configIdx]];
				valueB = b[cstDefaultSortFieldIdx3[configIdx]];

				switch(typeof a[cstDefaultSortFieldIdx3[configIdx]]) {
			    case "date":
						compVal = new Date(valueA) - new Date(valueB);
		        break;
			    case "string":
						compVal = valueA.localeCompare(valueB);
		        break;
			    case "number":
						compVal = valueA - valueB;
		        break;
			    default:
						compVal = 0;
		        break;
				}

				fact3 = (sortSign * compVal);

				// Criteria #4
				fact4 = (a[1].localeCompare(b[1]));

				// Results
				if (fact1 !== 0) {
					return fact1;
				} else if (fact2 !== 0) {
					return fact2;
				} else if (fact3 !== 0) {
					return fact3;
				} else {
					return fact4;
				}
			});
		}

		// Reset Rank column
		if (standingsItemData[0] !== "") {
			standingsItemData.forEach(function(row, idx) {
				row[0] = idx + 1;
			});
		}

		// set it
		standingsData[standingsIdx] = standingsItemData;

		this.setState({
			standingsData: standingsData,
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder,
		});
	}

	render() {
		//console.log('STAND: RENDER');
		//console.log(this.state);
		//console.log(this.state.standingsData);
		//console.log(this.state.standings.length);
		//console.log(this.state.tooltipOpen.length);
		let { configIdx, standings, standingIdx, summaryStats } = this.state;
    let { season } = this.props;
    const { connectedUser } = this.context;
		var hiddenRatingsMsgEnabled = !connectedUser?.isSeasonAdmin && season.hideRatingsInStandings;

		return (
			<div>
				{(standings.length > 1) ? this.dispStandTypesSelector(standings) : null}
				<br/>

				{hiddenRatingsMsgEnabled ? 
					<p className="noRatingMessages"> Les cotes des joueurs sont masquées pour les utilisateurs non-administrateurs </p> 
				: null}

				{(standings.length !== 0) ? this.dispStandings(standings, standingIdx) : null}

				<div className="no-print">
				{(configIdx === 0) ? this.createLegend() : null}
				{(configIdx === 1) ? this.createLegend_QVNEA_League_Notfinals() : null}
				{(configIdx === 2) ? this.createLegend_QVNEA_League_Finals() : null}
				{(configIdx === 3) ? this.createLegend_QVNEA_Tournament() : null}
				{(configIdx === 4) ? this.createLegend_BARAQUE500() : null}

				<p>
					<strong>Sommaire statistique</strong><br/>
					Parties jouées: {summaryStats.totalPJ}

					{((configIdx > 0) && (configIdx < 4)) ?
						<React.Fragment>
							<br/>
							TV: {summaryStats.totalTV}
						</React.Fragment>
					: null}

					{(configIdx !== 4) ?
						<React.Fragment>
							<br/>
							ERO: {summaryStats.totalERO}
						</React.Fragment>
					: null}

				</p>
				</div>
			</div>
		);
	}

	dispStandTypesSelector(standings) {
		return (
			<div className="row no-print">
			<div className="col-md-4">
				Options de classement
        <select className="form-control" value={this.state.standingIdx} onChange={this.standTypeChange}>
          {standings.map(this.createSelectItem)}
        </select>
			</div>
			</div>
		);
	}

  createSelectItem(standingsItem, standingsIdx) {
    return (
      <option value={standingsIdx} key={"stdType" + standingsIdx}>
      	{standingsItem.title}
      </option>
    );
  }

	standTypeChange(e) {
		this.resetAllSorting();
		this.setState({
			standingIdx: e.target.value
		});
		this.props.handleStandingIdxChange(e.target.value);
	}

	dispStandings(standings, standingsIdx) {
		var _this = this;
		var standingsItem = standings[standingsIdx];
		var standingsData = this.state.standingsData;

		// tests
		// standingsData[standingsIdx] = standingsData[standingsIdx].splice(0, 1);

		return (
			<div className="row">
			<div className="col-md-12">

				{/* NO-PRINT SECTION */}
				<div className="card no-print">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						{standingsItem.title.toUpperCase()}
					</div>

					<div className="card-body card-block">
						<div className="table-responsive tableFixHeader resizeVerticalStandings">
							<table className="table table-striped table-hover table-sm tableFix2col">
							<thead>
							<tr>
								{this.state.tableHeaders.map(function(elem, idx) {
									return _this.createStandingHdrRow(standingsIdx, elem, idx)
								})}
							</tr>
							</thead>
							<tbody>
								{(standingsData[standingsIdx].length !== 0) ?
									standingsData[standingsIdx].map(this.createStandingRow.bind(this, standingsIdx, true)) :
									<tr><td colSpan="99">(Aucune donnée)</td></tr>
								}
							</tbody>
							</table>
						</div>
					</div>
				</div>


				{/* ------------------------------------------------------------------------- */}
				{/* PRINT-ONLY SECTION */}
				<div className="print-only">
					<h5>{standingsItem.title.toUpperCase()}</h5>
					<div className="table-responsive print-container">
						<table className="table table-stripedtable-sm">
						<thead>
						<tr>
							{this.state.tableHeaders.map(function(elem, idx) {
								return _this.createStandingHdrRow(standingsIdx, elem, idx)
							})}
						</tr>
						</thead>
						<tbody>
								{(standingsData[standingsIdx].length !== 0) ?
									standingsData[standingsIdx].map(this.createStandingRow.bind(this, standingsIdx, false)) :
									<tr><td colSpan="99">(Aucune donnée)</td></tr>
								}
						</tbody>
						</table>
					</div>
				</div>
				{/* ------------------------------------------------------------------------- */}

		    </div>
		    </div>
		);
	}

	createStandingHdrRow(standingsIdx, hdrItem, hdrIdx) {
		var classNameStr = '';
		var onClickAction = function() {};

		if (hdrItem !== '#players') {
			// Sort with arrows
			// No sort on Rank (column 0)
			if (hdrIdx !== 0) {
				onClickAction = this.handleSortTable;
				classNameStr = 'statelo-sorting';
				if(hdrIdx === this.state.sortFieldIdx) {
					if (this.state.sortOrder === "asc") {
						classNameStr += ' statelo-sorting_asc';
					} else {
						classNameStr += ' statelo-sorting_desc';
					}
				}
			}

			return (
				<th key={"colid." + standingsIdx + '.' + hdrIdx} 
					id={"colid." + standingsIdx + '.' + hdrIdx} 
					className={classNameStr}
					onClick={onClickAction}>
					{hdrItem}
				</th>
			);
		}
	}

	createStandingRow(standingsIdx, withTooltips, tableDataRow, tableDataRowIdx) {

		if (withTooltips) {
			var playerscolIdx = this.state.tableHeaders.findIndex((elem) => (elem === '#players'));
			var teamPlayers = tableDataRow[playerscolIdx];
			teamPlayers = teamPlayers.sort((a, b) => (a.fullnameB.localeCompare(b.fullnameB)));

	    // Hide TRS if parameter is set and if we are not in Admin mode
	    let { season } = this.props;
	    const { connectedUser } = this.context;
			let hideRatings = !connectedUser?.isSeasonAdmin && season.hideRatingsInStandings;
			let showRating = (season.ratingTypeId !== '0') && !hideRatings;

			return (
				<tr key={'tr.' + tableDataRowIdx} className="stateloListItemPointer">

					{tableDataRow.slice(0, 1).map(this.createDataCell.bind(this, tableDataRowIdx, 0, 0))}
	  			{tableDataRow.slice(1, 2).map(this.createDataCell.bind(this, tableDataRowIdx, 1, 1))}
					{tableDataRow.slice(2).map(this.createDataCell.bind(this, tableDataRowIdx, 2, 0))}
	 
		 			{/* Tooltip */}
  				{/* Tooltip Title: team name */}
  				{/* Tooltip Body: players */}
				  <Tooltip placement="right" 
				  	target={'tooltipCell-' + tableDataRowIdx} toggle={() => {this.toggleTooltip(tableDataRowIdx)}}
				  	isOpen={this.state.tooltipOpen[tableDataRowIdx]} autohide={false}>
	    			
	  				<strong key={'tpnt.' + standingsIdx + '.' + tableDataRowIdx}> 
	  					{tableDataRow[1]}<br/> 
	  				</strong>

	    			{teamPlayers.map((tpn, tpnidx) => {
	    				
	    				var tpnRatingStr = tpn.ratingsStr;
	    				if ((this.state.configIdx >= 1) && (this.state.configIdx <= 3)) {
	    					tpnRatingStr = tpn.ratingsStrWithTemp;
	    				}
	    				return (
	    					<span key={'tpn.' + standingsIdx + '.' + tableDataRowIdx + '.' + tpnidx}> 
	    						{tpn.fullnameB} {showRating ? <span>[{tpnRatingStr}]</span> : null}	<br/> 
	    					</span>
	    				)
	    			})}
				  </Tooltip>
		    </tr>
	    );

		} else {

			return (
				<tr key={'tr.' + tableDataRowIdx} className="stateloListItemPointer">
					{tableDataRow.map(this.createDataCell.bind(this, tableDataRowIdx, 0, 0))}
		    </tr>
	    );			
		}
	}

	createDataCell(tableDataRowIdx, colOffset, tooltipOption, dataCell, dataCellIdx) {

		// offset column idx according to starting point
		dataCellIdx += colOffset;

		// Fixed number of decimals, converting to string, for averages or any other stats
		this.state.fixedDecimalsStats.forEach(function(fdItem, fdIOdx) {
			if (dataCellIdx === fdItem.fieldIdx) {
				dataCell = dataCell.toFixed(fdItem.decimals);
			}
		})

		if (this.state.tableHeaders[dataCellIdx] !== '#players') {

			// show tooltip only for teams in no-print version of standings to avoid bug with autohide
			if (tooltipOption === 1) {
				return (
					<td key={"tdcell." + tableDataRowIdx + '.' + dataCellIdx}>
						<span id={'tooltipCell-' + tableDataRowIdx}>
							{dataCell}
						</span>
					</td>
				);
			} else {
				return (
					<td key={"tdcell." + tableDataRowIdx + '.' + dataCellIdx}>
						{dataCell}
					</td>
				);
			}
		}
	}

  toggleTooltip(i) {
  	//console.log('toggleTooltip: ' + i)
    const newArray = this.state.tooltipOpen.map((element, index) => {
      return (index === i ? !element : false);
    });
    this.setState({
      tooltipOpen: newArray
    });
  }

	/* https://stackoverflow.com/questions/29810914/react-js-onclick-cant-pass-value-to-method */ 
	handleSortTable(e) {
		var _this = this;
		var standingsIdx = parseInt(e.target.id.split(".")[1], 10);
		var sortFieldIdx = parseInt(e.target.id.split(".")[2], 10);

		var configIdx = this.state.configIdx;
		var standingsData = this.state.standingsData;
		var sortOrder = this.state.sortOrder;
		var prevSortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[configIdx][sortFieldIdx];
		}

		this.setState({
			sortOrder: sortOrder,
			sortFieldIdx: sortFieldIdx,
		});

		this.sortOneStandingsData(configIdx, standingsData, standingsIdx, sortFieldIdx, sortOrder);
	}

	createLegend() {
		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						LÉGENDE
					</div>

				<div className="card-block">
				<table className="table table-striped table-sm">
					
				<tbody>
				<tr key='leg1'>
					<td><b>RG</b></td>
					<td>Rondes gagnées</td>
					<td><b>DIFF</b></td>
					<td>Différentiel</td>
				</tr>
				<tr key='leg2'>
					<td><b>PJ</b></td>
					<td>Parties Jouées</td>
					<td><b>ERO</b></td>
					<td>ERO Pour</td>
				</tr>
				<tr key='leg3'>
					<td><b>VIC</b></td>
					<td>Victoires</td>
					<td><b>EC</b></td>
					<td>ERO Contre</td>
				</tr>
				<tr key='leg4'>
					<td><b>DEF</b></td>
					<td>Défaites</td>
					<td><b>10-0</b></td>
					<td>Victoires 10-0</td>
				</tr>
				<tr key='leg5'>
					<td><b>% VIC</b></td>
					<td>% de victoires</td>
					<td><b>MOY</b></td>
					<td>Moyenne</td>
				</tr>
				<tr key='leg6'>
					<td><b>PP</b></td>
					<td>Points Pour</td>
					<td><b></b></td>
					<td></td>
				</tr>
				<tr key='leg7'>
					<td><b>PC</b></td>
					<td>Points Contre</td>
					<td><b></b></td>
					<td></td>
				</tr>
					
				</tbody>
				</table>
				</div>
				</div>
			</div>
			
			{this.showPrintButton()}
			</div>
		);
	}

	createLegend_QVNEA_League_Notfinals() {
		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						LÉGENDE
					</div>

				<div className="card-block">
				<table className="table table-striped table-sm">
				<tbody>
				<tr key='leg1'>
					<td><b>RG</b></td>
					<td>Rondes gagnées</td>
					<td><b>PC</b></td>
					<td>Points Contre</td>
				</tr>
				<tr key='leg2'>
					<td><b>RT</b></td>
					<td>Rondes totales</td>
					<td><b>DIFF</b></td>
					<td>Différentiel</td>
				</tr>
				<tr key='leg3'>
					<td><b>% RG</b></td>
					<td>% de rondes gagnées</td>
					<td><b>ERO</b></td>
					<td>ERO Pour</td>
				</tr>
				<tr key='leg4'>
					<td><b>PJ</b></td>
					<td>Parties Jouées</td>
					<td><b>EC</b></td>
					<td>ERO Contre</td>
				</tr>
				<tr key='leg5'>
					<td><b>VIC</b></td>
					<td>Victoires</td>
					<td><b>TVP</b></td>
					<td>Tables Vidées Pour</td>
				</tr>
				<tr key='leg6'>
					<td><b>DEF</b></td>
					<td>Défaites</td>
					<td><b>TVC</b></td>
					<td>Tables Vidées Contre</td>
				</tr>
				<tr key='leg7'>
					<td><b>% VIC</b></td>
					<td>% de victoires</td>
					<td><b>10-0</b></td>
					<td>Victoires 10-0</td>
				</tr>
				<tr key='leg8'>
					<td><b>PP</b></td>
					<td>Points Pour</td>
					<td><b>MOY</b></td>
					<td>Moyenne</td>
				</tr>

				</tbody>
				</table>
				</div>
				</div>
			</div>

			{this.showPrintButton()}
			</div>
		);
	}

	createLegend_QVNEA_League_Finals() {
		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						LÉGENDE
					</div>

				<div className="card-block">
				<table className="table table-striped table-sm">
				<tbody>
				<tr key='leg1'>
					<td><b>MG</b></td>
					<td>Matchs gagnés</td>
					<td><b>DIFF</b></td>
					<td>Différentiel</td>
				</tr>
				<tr key='leg2'>
					<td><b>% MG</b></td>
					<td>% de matchs gagnés</td>
					<td><b>ERO</b></td>
					<td>ERO Pour</td>
				</tr>
				<tr key='leg3'>
					<td><b>PJ</b></td>
					<td>Parties Jouées</td>
					<td><b>EC</b></td>
					<td>ERO Contre</td>
				</tr>
				<tr key='leg4'>
					<td><b>VIC</b></td>
					<td>Victoires</td>
					<td><b>TVP</b></td>
					<td>Tables Vidées Pour</td>
				</tr>
				<tr key='leg5'>
					<td><b>DEF</b></td>
					<td>Défaites</td>
					<td><b>TVC</b></td>
					<td>Tables Vidées Contre</td>
				</tr>
				<tr key='leg6'>
					<td><b>% VIC</b></td>
					<td>% de victoires</td>
					<td><b>10-0</b></td>
					<td>Victoires 10-0</td>
				</tr>
				<tr key='leg7'>
					<td><b>PP</b></td>
					<td>Points Pour</td>
					<td><b>MOY</b></td>
					<td>Moyenne</td>
				</tr>
				<tr key='leg8'>
					<td><b>PC</b></td>
					<td>Points Contre</td>
					<td><b></b></td>
					<td></td>
				</tr>


				</tbody>
				</table>
				</div>
				</div>
			</div>

			{this.showPrintButton()}
			</div>
		);
	}

	createLegend_QVNEA_Tournament() {
		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						LÉGENDE
					</div>

				<div className="card-block">
				<table className="table table-striped table-sm">
				<tbody>
				<tr key='leg1'>
					<td><b>MG</b></td>
					<td>Matchs gagnés</td>
					<td><b>DIFF</b></td>
					<td>Différentiel</td>
				</tr>
				<tr key='leg2'>
					<td><b>% MG</b></td>
					<td>% de matchs gagnés</td>
					<td><b>ERO</b></td>
					<td>ERO Pour</td>
				</tr>
				<tr key='leg3'>
					<td><b>PJ</b></td>
					<td>Parties Jouées</td>
					<td><b>EC</b></td>
					<td>ERO Contre</td>
				</tr>
				<tr key='leg4'>
					<td><b>VIC</b></td>
					<td>Victoires</td>
					<td><b>TVP</b></td>
					<td>Tables Vidées Pour</td>
				</tr>
				<tr key='leg5'>
					<td><b>DEF</b></td>
					<td>Défaites</td>
					<td><b>TVC</b></td>
					<td>Tables Vidées Contre</td>
				</tr>
				<tr key='leg6'>
					<td><b>% VIC</b></td>
					<td>% de victoires</td>
					<td><b>10-0</b></td>
					<td>Victoires 10-0</td>
				</tr>
				<tr key='leg7'>
					<td><b>PP</b></td>
					<td>Points Pour</td>
					<td><b>MOY</b></td>
					<td>Moyenne</td>
				</tr>
				<tr key='leg8'>
					<td><b>PC</b></td>
					<td>Points Contre</td>
					<td><b></b></td>
					<td></td>
				</tr>

				</tbody>
				</table>
				</div>
				</div>
			</div>

			{this.showPrintButton()}
			</div>
		);
	}

	createLegend_BARAQUE500() {
		// 	'Rang',	'Équipe',	'MJ', 'PJ', 'PP', 'PC', 'DIFF',	'HDCP', 'PTS TOT', 'MOY-500', 'Domicile'
		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						LÉGENDE
					</div>

				<div className="card-block">
				<table className="table table-striped table-sm">
				<tbody>
				<tr key='leg1'>
					<td><b>MJ</b></td>
					<td>Matchs joués</td>
					<td><b>DIFF</b></td>
					<td>Différentiel</td>
				</tr>
				<tr key='leg2'>
					<td><b>PJ</b></td>
					<td>Parties jouées</td>
					<td><b>HDCP</b></td>
					<td>Handicap</td>
				</tr>
				<tr key='leg3'>
					<td><b>PP</b></td>
					<td>Points pour</td>
					<td><b>PTS TOT</b></td>
					<td>Points totaux</td>
				</tr>
				<tr key='leg4'>
					<td><b>PC</b></td>
					<td>Points contre</td>
					<td><b>MOY-500</b></td>
					<td>Moyenne 500</td>
				</tr>

				</tbody>
				</table>
				</div>
				</div>
			</div>

			{this.showPrintButton()}
			</div>
		);
	}

	showPrintButton() {
		return (
			<div className="col-md-4 no-print">
				<button className="btn btn-secondary btn-sm btn-fluid pull-right" 
					onClick={this.printTable}> <i className="fa fa-print"></i>&nbsp;&nbsp;Imprimer le classement </button>

				<br/><br/>
				<div className="pull-right">
					<input type="checkbox" onChange={this.props.togglePrintLeagueMsg} checked={this.props.printLeagueMsg || false} />
					&nbsp;&nbsp;Imprimer le message de ligue
				</div>

			</div>
		)
	}

	printTable() {
		// replaceState remplace le URL affiché sur le printout
		var curURL = window.location.href;
		window.history.replaceState(history.state, '', '/');
		window.print();
		window.history.replaceState(history.state, '', curURL);
	}

}

export default TeamStandings_8B;
